import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import swal from 'sweetalert';
import { Api } from '../../api/Api';
import { Link } from 'react-router-dom';
import { ServerUrl } from '../../api/ServerUrl';
import FadeInOut from '../../tools/FadeInOut';
import { Helmet } from 'react-helmet';

const Testimoniul = () => {
    const { http } = Api();
    const httpCPage = ServerUrl;
    const [testimonials, setTestimonials] = useState([]);
    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [review, setReview] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [loader, setLoader] = useState('off');
    const [nameError, setNameError] = useState('');
    const [titleError, setTitleError] = useState('');
    const [reviewError, setReviewError] = useState('');
    const [backImage, setBackImage] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        http.get(`/front-get-testimoniul`)
            .then(res => { 
                if (res.data.reviews && res.data.reviews.length > 0) {
                    setTestimonials(res.data.reviews);
                    setBackImage(res.data.backImage);
                }
            })
            .catch(error => {
                console.error('Error fetching testimonial information:', error);
            });
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2, // Show 2 items by default
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const submitForm = () => {
        setLoader('on');
        setNameError('');
        setTitleError('');
        setReviewError('');
        const formData = new FormData();
        formData.append('name', name);
        formData.append('title', title);
        formData.append('review', review);
        formData.append('image', image);

        http.post('/store-testimoniul-from-customer', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(res => {
            if (res.data.status === '422') {
                setLoader('off');
                const errors = res.data.error;
                setNameError(errors.name ? errors.name[0] : '');
                setTitleError(errors.title ? errors.title[0] : '');
                setReviewError(errors.review ? errors.review[0] : '');
            } else {
                setLoader('off');
                setName('');
                setTitle('');
                setReview('');
                setImagePreview('');
                swal('Success', res.data.msg, 'success');
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    };

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    return (
        <div>

        <Helmet>
            <title>{backImage.meta_title || "Foot Balance Technology BD - Testimonials"}</title>
            <meta name="description" content={backImage.meta_description} />
            <meta property="og:title" content={backImage.og_title || backImage.meta_title} />
            <meta property="og:description" content={backImage.og_description || backImage.meta_description} />
            {backImage.og_image && (
                <meta property="og:image" content={`${ServerUrl}/backend/img/back_image/${backImage.og_image}`} />
            )}
        </Helmet>



        <section className="page-title pageTitleBg" style={{backgroundImage: `url(${ServerUrl}/backend/img/back_image/${backImage.image})`}}>
            <div className="auto-container">
                <h2>Testimonials</h2>
                <ul className="page-breadcrumb">
                <li><Link to="/">Home</Link></li>
                    <li>Testimonials</li>
                </ul>
            </div>
        </section>
        
        <section className="testimonial-section">
            <div className="auto-container">
            <FadeInOut>
                <div className="sec-title-two centered">
                    <h2 className='cusColorTitle'>What our customers say</h2>
                    <div className="title-text">Thousands have benefited from Foot Balance Technology</div>
                </div>
                </FadeInOut>

                <FadeInOut>
                <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-block p-2">
                            <div className="inner-box">
                                <div className="content">
                                    <div className="image-outer">
                                        <div className="image">
                                            <img src={`${httpCPage}/backend/img/testimoniul/${testimonial.image}`} alt="" />
                                        </div>
                                    </div>
                                    <h3>{testimonial.name}</h3>
                                    <div className="title">{testimonial.title}</div>
                                    <div className="text">{testimonial.review}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
                </FadeInOut>
            </div>
        </section>

        <FadeInOut>
        <section className='container'>
            <div className="text-center mt-5">
                <a href="https://maps.app.goo.gl/H6m3g56n6HZBCY9F6" target="_blank" type="submit" className="theme-btn btn-style-four border" rel="noopener noreferrer"><span className="txt">Review us on Google</span></a>
            </div>
        </section>
        </FadeInOut>
<section className="testimonial-form-section mb-5">
  <div className="auto-container">
    <FadeInOut>
      <div className="sec-title text-center mt-5 mb-4">
        <h2>Review Us</h2>
        <p className="text-muted">Do you have anything in your mind to let us know?</p>
      </div>
    </FadeInOut>

    <FadeInOut>
      <div className="row justify-content-center">
        {/* Image Upload */}
        <div className="col-12 text-center mb-4">
          <label htmlFor="userImage">
            <div
              className="image-box border rounded-circle mx-auto d-flex align-items-center justify-content-center"
              style={{ width: '170px', height: '170px', overflow: 'hidden', cursor: 'pointer' }}
            >
              {imagePreview ? (
                <img src={imagePreview} className="img-fluid rounded-circle" alt="Preview" />
              ) : (
                <img
                  src="https://www.shareicon.net/data/512x512/2016/05/24/770137_man_512x512.png"
                  style={{ width: '140px', height: '140px' }}
                  alt="Default"
                />
              )}
            </div>
            <input type="file" id="userImage" className="d-none" onChange={handleImageChange} />
            <span className="theme-btn btn-style-cus2 text-dark mt-2 d-inline-block">Upload</span>
          </label>
        </div>

        {/* Name */}
        <div className="col-md-5 mb-3">
          <input
            className="form-control"
            type="text"
            name="username"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <span className="text-danger">{nameError}</span>
        </div>

        {/* Title */}
        <div className="col-md-5 mb-3">
          <input
            className="form-control"
            type="text"
            name="title"
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <span className="text-danger">{titleError}</span>
        </div>

        {/* Review */}
        <div className="col-md-10 mb-3">
          <textarea
            className="form-control"
            name="review"
            placeholder="Write your review here..."
            rows="5"
            value={review}
            onChange={(e) => setReview(e.target.value)}
          ></textarea>
          <span className="text-danger">{reviewError}</span>
        </div>

        {/* Submit Button */}
        <div className="text-center">
          {loader === 'off' ? (
            <button type="submit" onClick={submitForm} className="theme-btn btn-style-cus mt-3">
              Submit
            </button>
          ) : (
            <div className="spinner-border text-dark mt-3" role="status"></div>
          )}
        </div>
      </div>
    </FadeInOut>
  </div>
</section>

        </div>
    )
}

export default Testimoniul;
